import { Helmet } from 'react-helmet-async';
import { Box, Center } from '@chakra-ui/react';
import ContainerBox from 'src/components/container-box/ContainerBox';
import TopBar from 'src/components/top-bar/TopBar';
import NavigationLink from 'src/components/top-bar/NavigationLink';
import colors from 'src/theme/colors';
import { ReactNode } from 'react';
import Page from 'src/components/page/Page';

interface LoginLayoutProps {
  children: ReactNode | ReactNode[];
  title: string;
}

export default function LoginLayout({ children, title }: LoginLayoutProps) {
  return (
    <Page title={title}>
      <Helmet>
        <style>{`body { 
          background-color: ${colors.podcastShade100};
        }
        @media screen and (max-width: 575px) {
          body {
            background-color: ${colors.white};
          }
        }
   `}</style>
        <meta name="viewport" content="width=device-width, initial-scale=1" />
      </Helmet>
      <TopBar>
        <Box>
          <NavigationLink isActive>Login</NavigationLink>
          <NavigationLink to="/signup">Register</NavigationLink>
        </Box>
      </TopBar>
      <Center minWidth="320px">
        <ContainerBox
          w={{ sm: '100%', md: '480px' }}
          minWidth={{ sm: '320px', md: '480px' }}
          my={{ sm: 0, md: '30px', xl: '42px', '2xl': '48px' }}
        >
          {children}
        </ContainerBox>
      </Center>
    </Page>
  );
}
